import React from 'react';

import { TableContainer, TableHead, TableBody, TableCell, TableRow, Table, makeStyles, Typography } from '@material-ui/core';

import TableFooter from './TableFooter';

const useStyles = makeStyles(() => ({
  tableContainer: {
    border: '1px solid #F5F5F5',
    borderRadius: '10px',
  },
  tableRoot: {
    borderSpacing: '0px !important',
  },
  tableRow: {
    '&:hover': {
      background: '#F5F5F5',
    },
  },
  tableRowSelected: {
    background: '#F5F5F5',
  },
  typographyNoDataAvailable: {
    color: '#999999',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '14px',
    padding: '8px',
  },
  typographyTableHeader: {
    color: '#999999',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '14px',
  },
}));

export default ({ columns, data, tableId = 'table', options, headerClassName = '', children, hideHeader }) => {
  const classes = useStyles();

  const handleRowSelectionChange = ({ itemData, index }) => {
    if (options?.onRowSelectionChange) options.onRowSelectionChange({ index, itemData });
  };

  const handleChangePage = (page) => {
    if (options?.onTableChange) options.onTableChange('changePage', { page });
  };

  const renderNoDataAvailable = () => {
    const headLength = columns.length;

    return (
      <TableRow>
        <TableCell colSpan={headLength}>
          <Typography align="center" className={classes.typographyNoDataAvailable}>
            No Data Available
          </Typography>
        </TableCell>
      </TableRow>
    );
  };

  const renderTableHead = (_columns) => {
    return _columns.map((col) => {
      return (
        <TableCell key={`table-head-${col.name}`}>
          <span className={`${classes.typographyTableHeader} ${headerClassName}`}>{col.label}</span>
        </TableCell>
      );
    });
  };

  const renderTableBody = (tableData) => {
    if (!tableData || !tableData?.length) return renderNoDataAvailable();

    return tableData.map((itemData, index) => {
      const key = `${tableId}-table-row-${index}`;
      const isRowSelected = options?.checkIsRowSelected ? options.checkIsRowSelected(options.rowsSelected, itemData) : false;

      return (
        <TableRow onClick={() => handleRowSelectionChange({ index, itemData })} className={`${classes.tableRow} ${isRowSelected && classes.tableRowSelected}`} key={key}>
          {renderTableBodyData(columns, itemData)}
        </TableRow>
      );
    });
  };

  const renderTableBodyData = (_columns, dataItem) => {
    return _columns.map((col, index) => {
      const currentValue = dataItem?.[col.name] || undefined;
      const key = `${tableId}-table-data-${col.name}-${index}`;
      if (col.render) {
        return (
          <TableCell style={{ borderTop: '1px solid #F5F5F5' }} key={key}>
            {col.render(currentValue, dataItem)}
          </TableCell>
        );
      }

      return <TableCell key={key}>{currentValue}</TableCell>;
    });
  };

  return (
    <div>
      <div className={classes.tableContainer}>
        <div style={{ display: 'block', width: '100%' }}>{children}</div>
        <TableContainer>
          <Table size="medium" className={classes.tableRoot}>
            {!hideHeader && (
              <TableHead>
                <TableRow>{renderTableHead(columns)}</TableRow>
              </TableHead>
            )}
            <TableBody>{renderTableBody(data)}</TableBody>
          </Table>
        </TableContainer>
      </div>
      <TableFooter count={options.count || 0} page={options.page || 0} rowsPerPage={options.limit || 10} changePage={handleChangePage} />
    </div>
  );
};
